var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"no-sl no-pe",style:(_vm.imgStyle),attrs:{"src":_vm.imgSrc,"loading":_vm.loading,"crossorigin":"anonymous"},on:{"error":function($event){_vm.isError = true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }